import { PageTabs } from "types/ui/tab";

export interface WorkTab {
  id: PageTabs;
  title: string;
  component: React.ReactNode;
}

export interface DataCardItem {
  id: number;
  title: string | JSX.Element;
  description: string;
  status: number;
  dueDate: string | undefined;
  created_by: string;
  assigned_to: string;
  priority: "Высокая" | "Средняя" | "Низкая" | undefined;
}

export interface DataListResponse {
  [key: number]: {
    data: DataCardItem[];
    total_count: number;
  };
}

export const DataListDefault: DataListResponse = {
  0: {
    data: [],
    total_count: 0,
  },
};
